export enum IncidentStatusEnum {
  Open = 0,
  Closed = 1,
  Verified = 2,
  Snoozed = 3,
  InProgress = 4,
  OnHold = 5,
  Approved = 6,
  Rejected = 7,
  Completed = 8,
}
export const StatusStringToEnum: Record<string, IncidentStatusEnum> = {
  Open: IncidentStatusEnum.Open,
  Close: IncidentStatusEnum.Closed,
  Verified: IncidentStatusEnum.Verified,
  Snooze: IncidentStatusEnum.Snoozed,
  'In-Progress': IncidentStatusEnum.InProgress,
  'On-Hold': IncidentStatusEnum.OnHold,
  Approved: IncidentStatusEnum.Approved,
  Rejected: IncidentStatusEnum.Rejected,
  Completed: IncidentStatusEnum.Completed,
};
export const EnumToStatusString: Record<IncidentStatusEnum, string> = {
  [IncidentStatusEnum.Open]: 'Open',
  [IncidentStatusEnum.Closed]: 'Closed',
  [IncidentStatusEnum.Verified]: 'Verified',
  [IncidentStatusEnum.Snoozed]: 'Snoozed',
  [IncidentStatusEnum.InProgress]: 'In-Progress',
  [IncidentStatusEnum.OnHold]: 'On-Hold',
  [IncidentStatusEnum.Approved]: 'Approved',
  [IncidentStatusEnum.Rejected]: 'Rejected',
  [IncidentStatusEnum.Completed]: 'Completed',
};
export const AllowedTransitions: Record<
  IncidentStatusEnum,
  IncidentStatusEnum[]
> = {
  [IncidentStatusEnum.Open]: [
    IncidentStatusEnum.Approved,
    IncidentStatusEnum.Rejected,
    IncidentStatusEnum.InProgress,
    IncidentStatusEnum.Completed,
    IncidentStatusEnum.Verified,
    IncidentStatusEnum.Snoozed,
    IncidentStatusEnum.Closed,
    IncidentStatusEnum.OnHold,
  ],
  [IncidentStatusEnum.Approved]: [
    IncidentStatusEnum.Rejected,
    IncidentStatusEnum.InProgress,
    IncidentStatusEnum.Completed,
    IncidentStatusEnum.Verified,
    IncidentStatusEnum.Snoozed,
    IncidentStatusEnum.Closed,
    IncidentStatusEnum.OnHold,
  ],
  [IncidentStatusEnum.Rejected]: [
    IncidentStatusEnum.InProgress,
    IncidentStatusEnum.Completed,
    IncidentStatusEnum.Verified,
    IncidentStatusEnum.Snoozed,
    IncidentStatusEnum.Closed,
    IncidentStatusEnum.OnHold,
  ],
  [IncidentStatusEnum.InProgress]: [
    IncidentStatusEnum.Completed,
    IncidentStatusEnum.Verified,
    IncidentStatusEnum.Snoozed,
    IncidentStatusEnum.Closed,
    IncidentStatusEnum.OnHold,
  ],
  [IncidentStatusEnum.Completed]: [
    IncidentStatusEnum.Verified,
    IncidentStatusEnum.Snoozed,
    IncidentStatusEnum.Closed,
    IncidentStatusEnum.OnHold,
  ],
  [IncidentStatusEnum.Verified]: [
    IncidentStatusEnum.Snoozed,
    IncidentStatusEnum.Closed,
    IncidentStatusEnum.OnHold,
  ],
  [IncidentStatusEnum.OnHold]: [
    IncidentStatusEnum.Closed,
    IncidentStatusEnum.Snoozed,
    IncidentStatusEnum.Open,
  ],
  [IncidentStatusEnum.Snoozed]: [
    IncidentStatusEnum.Closed,
    IncidentStatusEnum.Open,
  ],
  [IncidentStatusEnum.Closed]: [IncidentStatusEnum.Open],
};
